import { render, staticRenderFns } from "./tooltip-tertiary.vue?vue&type=template&id=2fb27dfd&scoped=true"
import script from "./tooltip-tertiary.vue?vue&type=script&lang=js"
export * from "./tooltip-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb27dfd",
  null
  
)

export default component.exports